import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import type { SkillVerdict } from '@/modules/jobs/signal/types';
import { toVerdict } from '@/modules/jobs/signal/verdict';

/**
 * Lints committed skills via `/ai/skill-lint` (a billable LLM call — call it on skill-commit, not per keystroke,
 * and only for the newly-added skill(s)). Wire `verdict` (a bare `string`) is narrowed to the local union here.
 */
export const useSkillLintMutation = () =>
  useMutation({
    mutationFn: async (skills: string[]): Promise<SkillVerdict[]> => {
      const { data } = await fetchClient.POST('/ai/skill-lint', {
        body: { skills },
      });
      return (data ?? []).map((item) => ({
        input: item.input,
        canonical: item.canonical,
        verdict: toVerdict(item.verdict),
        // `|| null` (not `??`): an empty served string collapses to null so consumers fall back to the canonical.
        display: item.display || null,
      }));
    },
  });
